import { extendLocale } from '@nuxt/ui/composables/defineLocale';
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { buildNuxtUiOverrides, resolveNuxtUiLocale } from '#layers/ui/utils/nuxt-ui-locale';

/**
 * Reactive Nuxt UI `Locale`: bundled base for the active app locale, deep-merged
 * with the app-controlled override subtree. Recomputes when the app locale
 * (and therefore the resolved translations) changes.
 */
export function useNuxtUiLocale() {
	const { t, locale } = useI18n();

	return computed(() => {
		// `locale.value` referenced so the computed re-runs on locale change.
		const base = resolveNuxtUiLocale(locale.value);
		return extendLocale(base, { messages: buildNuxtUiOverrides(t) });
	});
}
